import { Injectable, computed, inject } from "@angular/core";
import { LanguageService } from "./language.service";

@Injectable({ providedIn: "root" })
export class DateService {
    private readonly languageService = inject(LanguageService);

    public readonly dateFormat = computed(() => {
        const language = this.languageService.language();
        return language === "fr-CA" ? "MMM dd, yyyy" : "dd MMM yyyy";
    });
}
